import {isDeterministic} from '../constants.js';
import DeterministicMixByType from '../DeterministicMixByType.js';
import MixByType from '../MixByType.js';

// An operation has a mix that it operates on.
// It is extended to form actual operations on the mix
// such as "Add Event", "Insert Event", "Delete", etc

class Operation {
    constructor(mix, type) {
        this.mix = mix;
        this.type = type;
    }

    get mixByType() {
        let mapping = isDeterministic(this.type) ?
            this.mix.deterministicMixesByType :
            this.mix.mixesByType;

        if (!(this.type in mapping)) {
            if (isDeterministic(this.type)) {
                mapping[this.type] = new DeterministicMixByType(this.type);
            } else {
                mapping[this.type] = new MixByType(this.type);
            }
        }

        return mapping[this.type];
    }

    get events() {
        return this.mixByType.events;
    }

    set events(x) {
        this.mixByType.events = x;
    }

    execute() {}

    getDuration(event) {
        let previous = undefined;
        for (let i=0; i < this.events.length; i++) {
            let currentEvent = this.events[i];
            if (previous === event) {
                return currentEvent.step - event.step;
            }
        }
        return 0;
    }

    calculateDurations() {
        // first merge any equivalents
        let events = [];
        let previous = undefined;
        for (let i=0; i < this.events.length; i++) {
            let event = this.events[i];
            if (previous === undefined || !event.isEquivalent(previous)) {
                events.push(event);
            } else {
            }
            previous = event;
        }

        this.events = events;
        
        // now calculate the durations
        previous = undefined;
        for (let i=0; i < this.events.length; i++) {
            let event = this.events[i];
            if (previous !== undefined) {
                previous.duration = event.step - previous.step;
            }
            previous = event;
        }
    }
}

export default Operation;
